import { ICloneable } from 'app/shared/interfaces/cloneable.interface';
import { FilterOperatorType } from 'app/shared/models/filter-operator-type.model';
import { RandomUtils } from '../../../../utils/random.utils';

export class MapFilterState implements ICloneable<MapFilterState> {
  id?: string;
  name?: string;
  filters: MapFilterItem[];

  constructor(state?: Partial<MapFilterState>) {
    this.id = state?.id;
    this.name = state?.name;
    this.filters = state?.filters?.map((x) => new MapFilterItem(x)) ?? [];
  }

  clone() {
    return new MapFilterState(this);
  }
}

export enum MapFilterType {
  Localization = 'Localization',
  EntityType = 'EntityType',
  Entity = 'Entity',
  ObjectType = 'ObjectType',
  Attributes = 'Attributes',
  ObjectId = 'ObjectId',
}

export enum MapFilterValueType {
  String = 'string',
  Number = 'number',
  Date = 'date',
}

export enum MapFilterFieldHandleType {
  None = 'none',
  Lower = 'lower',
}

export class MapFilterItem implements ICloneable<MapFilterItem> {
  static readonly DEFAULT_VALUE_ALL = `~Default::ALL`;

  static stringfyValue(value: any): string {
    if (value instanceof Date) {
      return value.toISOString();
    }

    return value.toString();
  }

  static parseValue(value: string, valueType: MapFilterValueType): any {
    switch (valueType) {
      case MapFilterValueType.Date:
        return new Date(value);
      case MapFilterValueType.Number:
        return Number(value);
      case MapFilterValueType.String:
      default:
        return String(value);
    }
  }

  static getValueType(value: any): MapFilterValueType {
    if (value instanceof Date) {
      return MapFilterValueType.Date;
    }

    switch (typeof value) {
      case 'number':
        return MapFilterValueType.Number;
      case 'string':
      default:
        return MapFilterValueType.String;
    }
  }

  static handleField(
    field: string,
    fieldHandleType?: MapFilterFieldHandleType
  ): string {
    switch (fieldHandleType) {
      case MapFilterFieldHandleType.Lower:
        return `lower(${field})`;
      case MapFilterFieldHandleType.None:
      default:
        return field;
    }
  }

  id: string;
  type: MapFilterType;
  text: string;
  field: string;
  fieldHandleType: MapFilterFieldHandleType;
  valueAsStr: string;
  valueType: MapFilterValueType;
  operator: FilterOperatorType;

  get value() {
    return MapFilterItem.parseValue(this.valueAsStr, this.valueType);
  }

  get fieldHandled() {
    return MapFilterItem.handleField(this.field, this.fieldHandleType);
  }

  constructor(item?: Partial<MapFilterItem>) {
    this.id = item?.id ?? RandomUtils.uniqId();
    this.type = item?.type;
    this.text = item?.text;
    this.field = item?.field;
    this.fieldHandleType =
      item?.fieldHandleType ?? MapFilterFieldHandleType.None;
    this.valueAsStr = item?.valueAsStr;
    this.valueType = item?.valueType ?? MapFilterValueType.String;
    this.operator = item?.operator ?? FilterOperatorType.Eq;
  }

  clone() {
    return new MapFilterItem(this);
  }
}
